"use client";

import React from "react";
import { ArrowRight, ClipboardCheck, Dog, Utensils } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const services = [{
  icon: <Utensils className="size-8 text-primary" />,
  title: "השגחה בבית חולים",
  description: "ליווי צמוד ומקצועי בבתי החולים בירושלים, המבטיח שהיקיר לכם לעולם לא יישאר לבד. הצוות שלנו דואג לתקשורת מול הצוות הרפואי, סיוע בניידות, האכלה ושמירה על רווחת המטופל לאורך כל שעות היממה, תוך מתן שקט נפשי מלא למשפחה המודאגת.",
  link: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  icon: <ClipboardCheck className="size-8 text-primary" />,
  title: "ניהול מחלות כרוניות",
  description: "טיפול מקיף ומותאם אישית למתמודדים עם דמנציה, אלצהיימר, סוכרת או מחלות לב. אנו בונים תוכנית עבודה הכוללת מעקב תרופתי קפדני, ניטור מדדים חיוניים ופעילות קוגניטיבית מעוררת, במטרה לשמר את איכות החיים המקסימלית בסביבה הביתית המוכרת והבטוחה.",
  link: "/CaregiverServicePagesPage"
}, {
  icon: <Dog className="size-8 text-primary" />,
  title: "מטפל סיעודי בבית",
  description: "שירותי סיעוד פרטיים בבית המטופל הכוללים עזרה ברחצה, הלבשה, ניידות והכנת ארוחות מזינות. המטפלים שלנו נבחרים בקפידה לא רק בזכות המקצועיות, אלא גם בזכות החמלה והסבלנות, כדי להעניק תמיכה רגשית ופיזית מלאה המותאמת לקצב החיים האישי של כל קשיש.",
  link: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}];
export default function ServicesGrid() {
  return <section data-section-id="260926" id="שירותים-סיעודיים-בירושלים" className="bg-background py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4 lg:gap-6">
          {/* Left Column: Header Content */}
          <div className="flex flex-col items-start justify-center lg:pr-8">
            <span className="mb-4 text-sm font-bold tracking-wider text-muted-foreground uppercase font-default">
              השירותים שלנו
            </span>
            <h2 className="mb-6 font-default text-3xl font-bold leading-tight text-primary md:text-4xl">
              מעטפת סיעודית מקצועית בירושלים והסביבה
            </h2>
            <p className="mb-8 font-default text-base leading-relaxed text-muted-foreground">
              אנו מספקים פתרונות סיעוד מתקדמים המשלבים מקצועיות רפואית עם יחס אישי וחם, כדי להבטיח ביטחון ונוחות ליקיריכם בכל מצב בריאותי.
            </p>
            <Button asChild size="lg" className="rounded-lg px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
              <Link to="/CaregiverServicePagesPage">לכל השירותים שלנו</Link>
            </Button>
          </div>

          {/* Right Columns: Service Cards */}
          {services.map((service, i) => <div key={i} data-index={i} className="group flex flex-col rounded-lg border border-border bg-card p-8 transition-all duration-300 hover:border-primary/20 hover:shadow-lg">
              <div className="mb-6 inline-flex rounded-lg bg-accent p-4 transition-colors group-hover:bg-accent/20">
                {service.icon}
              </div>
              <h3 className="mb-4 font-default text-xl font-bold text-foreground">
                {service.title}
              </h3>
              <p className="mb-8 flex-grow font-default text-sm leading-relaxed text-muted-foreground">
                {service.description}
              </p>
              <Link to={service.link} className="inline-flex items-center gap-2 font-default text-sm font-medium text-primary transition-colors hover:text-primary/80">
                למידע נוסף
                <ArrowRight className="size-4 transition-transform group-hover:-translate-x-1 rotate-180" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}